"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isSwapOfferTransaction(transaction) {
    return transaction.kind === "bcp/swap_offer";
}
exports.isSwapOfferTransaction = isSwapOfferTransaction;
function isSwapClaimTransaction(transaction) {
    return transaction.kind === "bcp/swap_claim";
}
exports.isSwapClaimTransaction = isSwapClaimTransaction;
function isSwapAbortTransaction(transaction) {
    return transaction.kind === "bcp/swap_abort";
}
exports.isSwapAbortTransaction = isSwapAbortTransaction;
function isSwapTransaction(transaction) {
    return (isSwapOfferTransaction(transaction) ||
        isSwapClaimTransaction(transaction) ||
        isSwapAbortTransaction(transaction));
}
exports.isSwapTransaction = isSwapTransaction;
// Non-transactions
var SwapProcessState;
(function (SwapProcessState) {
    SwapProcessState["Open"] = "open";
    SwapProcessState["Claimed"] = "claimed";
    SwapProcessState["Aborted"] = "aborted";
})(SwapProcessState = exports.SwapProcessState || (exports.SwapProcessState = {}));
function isSwapProcessStateOpen(state) {
    return state === SwapProcessState.Open;
}
exports.isSwapProcessStateOpen = isSwapProcessStateOpen;
function isSwapProcessStateClaimed(state) {
    return state === SwapProcessState.Claimed;
}
exports.isSwapProcessStateClaimed = isSwapProcessStateClaimed;
function isSwapProcessStateAborted(state) {
    return state === SwapProcessState.Aborted;
}
exports.isSwapProcessStateAborted = isSwapProcessStateAborted;
function isOpenSwap(swap) {
    return isSwapProcessStateOpen(swap.kind);
}
exports.isOpenSwap = isOpenSwap;
function isClaimedSwap(swap) {
    return isSwapProcessStateClaimed(swap.kind);
}
exports.isClaimedSwap = isClaimedSwap;
function isAbortedSwap(swap) {
    return isSwapProcessStateAborted(swap.kind);
}
exports.isAbortedSwap = isAbortedSwap;
/** a type guard to use in the swap-based queries  */
function isAtomicSwapRecipientQuery(query) {
    return query.recipient !== undefined;
}
exports.isAtomicSwapRecipientQuery = isAtomicSwapRecipientQuery;
/** a type guard to use in the swap-based queries  */
function isAtomicSwapSenderQuery(query) {
    return query.sender !== undefined;
}
exports.isAtomicSwapSenderQuery = isAtomicSwapSenderQuery;
/** a type guard to use in the swap-based queries  */
function isAtomicSwapIdQuery(query) {
    return query.id !== undefined;
}
exports.isAtomicSwapIdQuery = isAtomicSwapIdQuery;
/** a type guard to use in the swap-based queries  */
function isAtomicSwapHashQuery(query) {
    return query.hash !== undefined;
}
exports.isAtomicSwapHashQuery = isAtomicSwapHashQuery;
function isAtomicSwapConnection(conn) {
    const check = conn;
    return typeof check.getSwaps === "function" && typeof check.watchSwaps === "function";
}
exports.isAtomicSwapConnection = isAtomicSwapConnection;
//# sourceMappingURL=atomicswaptypes.js.map